(function () {
  function replaceImage(image, url) {
    if (!image || image.dataset.pawvernExactProduct === 'true') return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = url;
    image.dataset.pawvernExactProduct = 'true';
  }

  function replaceImages(root, url) {
    if (!root) return;
    root.querySelectorAll('img').forEach(function (image) {
      replaceImage(image, url);
    });
  }

  function installExactHero() {
    var config = document.querySelector('[data-pawvern-dental-gallery-hero]');
    if (!config) return;

    var url = config.getAttribute('data-pawvern-dental-gallery-hero');
    if (!url) return;

    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var firstSlide = gallery.querySelector('.product__media-item');
      var firstThumb = gallery.querySelector('.thumbnail-list__item');
      replaceImages(firstSlide, url);
      replaceImages(firstThumb, url);
    });

    var modal = document.querySelector('.product-media-modal__content');
    var firstModalMedia = modal && modal.firstElementChild;
    replaceImages(firstModalMedia, url);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installExactHero);
  } else {
    installExactHero();
  }
})();
